import { render, staticRenderFns } from "./wdzhSet.vue?vue&type=template&id=735e33b0&scoped=true&"
import script from "./wdzhSet.vue?vue&type=script&lang=js&"
export * from "./wdzhSet.vue?vue&type=script&lang=js&"
import style0 from "./wdzhSet.vue?vue&type=style&index=0&id=735e33b0&prod&lang=scss&scoped=true&"
import style1 from "./wdzhSet.vue?vue&type=style&index=1&id=735e33b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735e33b0",
  null
  
)

export default component.exports